/**
 * Currency actions.
 * @module actions/currency/currency
 */

export const SET_CURRENCY = 'SET_CURRENCY';

/**
 * Set the currency used to display prices throughout the app.
 * @function setCurrency
 * @param {string} currency Currency code ('USD' or 'EUR').
 * @returns {Object} Set currency action.
 */
export function setCurrency(currency) {
  return {
    type: SET_CURRENCY,
    currency,
  };
}
